var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apprentice-simple-card"},[_c('p',[_vm._v(_vm._s(_vm.$t('google_drive.cannot_link_file_to_account')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }